import { type ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

// https://tabler.io/icons/icon/password-user
const UserPasswordIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  const defaultClassnames =
    "icon icon-tabler icon-tabler-password-user h-3 w-3";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge(defaultClassnames, className)}
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M12 17v4"></path>
      <path d="M10 20l4 -2"></path>
      <path d="M10 18l4 2"></path>
      <path d="M5 17v4"></path>
      <path d="M3 20l4 -2"></path>
      <path d="M3 18l4 2"></path>
      <path d="M19 17v4"></path>
      <path d="M17 20l4 -2"></path>
      <path d="M17 18l4 2"></path>
      <path d="M9 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
      <path d="M7 14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2"></path>
    </svg>
  );
};

export default UserPasswordIcon;
